const counters = {};

/**
 * Creates unique ids, optinally with a namespace to allow for a counter per namespace
 * 
 * @param {string} ns Optional namespace of the returned guid
 * 
 * @return string
 */
export default function guid(ns = '__default__') {
  if (!counters[ns]) {
    counters[ns] = 1;
  }
  
  if (ns !== '__default__') {
    return `${ns}:${counters[ns]++}`;
  } else {
    return (counters[ns]++).toString();
  }
};